// 주어진 두 값 사이의 정수인 난수를 생성한다. 반환값은 min(단, min이 정수가 아니면 min보다 큰 최소의 정수)보다 크거나 같으며, max보다 작다.
export const getRandomInt = (min: number, max: number) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min)) + min; //최댓값은 제외, 최솟값은 포함
};

export const logError = (...args: unknown[]) => {
  // const [first, ...rest] = args;
  // eslint-disable-next-line no-console
  // console.log(
  //   `%c[codenbutter] %c${first}`,
  //   "color: #999;",
  //   "color: inherit;",
  //   ...rest
  // );
  // eslint-disable-next-line no-console
  console.log("[CODENBUTTER]", ...args);
};

/** 디버그 모드일 때에만 로그를 출력합니다. */
export const logDebug = (...args: unknown[]) => {
  if (window._cnbDebugMode) {
    // eslint-disable-next-line no-console
    console.log(
      "[CODENBUTTER]",
      ...args,

      `${
        window.CodenButter?.lastPageLoadedAt
          ? Date.now() - window.CodenButter.lastPageLoadedAt.getTime()
          : "N/A"
      }ms`
    );
  }
};

/** 전역 디버그 모드 여부를 판단한다. window._cnbDebugMode, localStorage, URL 파라미터 순서로 체크 */
export const isCnbDebugMode = (extraSearchParamKeys: string[] = []) => {
  try {
    const url = new URL(location.href);
    const yes = (v: unknown) => ["1", "true", "yes"].includes(String(v));
    const hasParam = ["cb_debug", ...extraSearchParamKeys].some((k) =>
      yes(url.searchParams.get(k))
    );
    const hasWindow = Boolean(window._cnbDebugMode);
    const hasLS = Boolean(window.localStorage.getItem("_cnbDebugMode"));
    return hasWindow || hasLS || hasParam;
  } catch {
    return Boolean(window._cnbDebugMode);
  }
};

export const isElement = (object: unknown): object is Element =>
  object instanceof Element;

export const createManualPromise = <T>() => {
  let resolve: (value: T) => void;
  let reject: (reason?: unknown) => void;

  const promise = new Promise<T>((res, rej) => {
    resolve = res;
    reject = rej;
  });

  return { promise, resolve: resolve!, reject: reject! };
};

// scroll을 고려한 윈도우 가로 사이즈
export const getWindowWidth = () => {
  return Math.max(
    document.body.scrollWidth,
    document.documentElement.scrollWidth,
    document.body.offsetWidth,
    document.documentElement.offsetWidth,
    document.body.clientWidth,
    document.documentElement.clientWidth
  );
};

// scroll을 고려한 윈도우 세로 사이즈
export const getWindowHeight = () => {
  return Math.max(
    document.body.scrollHeight,
    document.documentElement.scrollHeight,
    document.body.offsetHeight,
    document.documentElement.offsetHeight,
    document.body.clientHeight,
    document.documentElement.clientHeight
  );
};
